/**
 * 引导图相关
 */
import OSS from "ali-oss";
import $store from "../../_common/store/user";
export default {
  created() {
    $store.dispatch("getOssToken");
  },
  methods: {
    /**
     *
     * @param file 文件对象
     * @param _bojName 上传保存位置文件夹 非必填
     * @returns {Promise<any>}
     */
    ossUpload(file, _bojName) {
      return new Promise((resolve, reject) => {
        let client = new OSS($store.state.ossConfig);

        let bojName =
          _bojName || "dwwb/portal/project/" + new Date().getTime() + "/";
        async function putBlob() {
          try {
            let result = await client.put(bojName + file.name, file);
            resolve(result);
          } catch (e) {
            reject(e);
          }
        }
        putBlob();
      });
    },
    ossMultipartUpload(file, _bojName) {
      return new Promise((resolve, reject) => {
        let client = new OSS(this.$store.state.ossConfig);

        let bojName =
          _bojName || "dwwb/portal/project/" + new Date().getTime() + "/";
        async function multipartUpload() {
          try {
            let result = await client.multipartUpload(
              bojName + file.name,
              file
            );
            resolve(result);
          } catch (e) {
            reject(e);
          }
        }
        multipartUpload();
      });
    },
  },
};
